export default "__VITE_ASSET__de8e22b2__"